import React from 'react';

function Footer() {
  return (
    <footer className="py-3 px-4 border-top bg-white text-center">
      <small className="text-muted">
        2025 &copy; Skillengine Inc. &mdash; Cranova Admin
      </small>
    </footer>
  );
}

export default Footer;
